import { useTheme } from '@mui/material';

export const TryAgainIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx={20} cy={20} r={12.928} fill={primaryBackground} />
            <path
                d="M20 35.85c0 .451-.366.819-.816.797a16.666 16.666 0 1 1 17.463-17.463.786.786 0 0 1-.797.816.852.852 0 0 1-.838-.816A15.033 15.033 0 0 0 9.37 9.37a15.034 15.034 0 0 0 9.815 25.643c.45.025.816.388.816.838Z"
                fill={primaryStroke}
            />
            <path
                d="m31.97 17.682 4.126 2.823 2.823-4.127"
                stroke={primaryStroke}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
